<div class="page-container">
  <intelishs-page-header
    title="Calendario de Ausencias"
    subtitle="Vista general de vacaciones del equipo"
  />

  <!-- Unified controls bar: leyenda + filtros -->
  <div class="cal-controls">
    <!-- Leyenda Y filtro. Eran `<span>` inertes dibujados igual que los chips de
         filtro del resto de la app, así que prometían un filtro por estatus que
         no existía; el calendario solo filtraba por empleado y área.

         Semántica de leyenda de gráfica: los cuatro arrancan encendidos —el
         estado inicial es el de siempre— y apagar uno esconde sus eventos. Eso
         permite combinar (ver solo pendientes y aprobadas por director) en vez
         de obligar a elegir una sola categoría.

         El color sale de `colorLeyenda`, que es la MISMA fuente que pinta el
         cuadrito en la rejilla: una leyenda que mostrara un tono aproximado
         dejaría de cumplir su único trabajo. Por eso tampoco usa
         `intelishs-stat-chip`, cuya paleta es propia y no tiene el ámbar de los
         festivos. -->
    <div class="cal-legend">
      @for (item of leyenda; track item.clave) {
        <button
          type="button"
          class="cal-legend-item"
          [class.cal-legend-item--apagado]="!esVisible(item.clave)"
          [attr.aria-pressed]="esVisible(item.clave)"
          [title]="esVisible(item.clave) ? 'Ocultar ' + item.etiqueta : 'Mostrar ' + item.etiqueta"
          (click)="toggleEstatus(item.clave)"
        >
          <span
            class="cal-legend-dot"
            [style.background]="esVisible(item.clave) ? colorLeyenda(item.clave) : 'transparent'"
            [style.border-color]="colorLeyenda(item.clave)"
          ></span>
          {{ item.etiqueta }}
        </button>
      }
    </div>

    <div class="cal-controls-actions">
      @if (empleadoFilterId() !== null) {
        <nz-tag nzColor="blue" class="cal-filter-chip">
          <nz-icon nzType="user" />
          <span>{{ empleadoFilterNombre() }}</span>
          <nz-icon
            nzType="close"
            class="cal-filter-chip-close"
            (click)="limpiarFiltroEmpleado()"
            title="Quitar filtro de empleado"
          />
        </nz-tag>
      }
      <nz-select
        class="cal-area-select"
        [ngModel]="areaFilter()"
        (ngModelChange)="areaFilter.set($event)"
        nzPlaceHolder="Filtrar por área"
        nzAllowClear
      >
        @for (area of areas(); track area) {
          <nz-option [nzValue]="area" [nzLabel]="area" />
        }
      </nz-select>
      @if (hayFiltroActivo()) {
        <!-- Circular como el de recargar: son dos acciones de la misma barra y
             del mismo peso, y con texto una pesaba el doble que la otra. El
             icono es `clear` y no `filter`: un embudo solo se lee como "abrir
             filtros", no como "quitarlos". -->
        <button
          type="button"
          class="btn-refresh-circle"
          nz-tooltip
          nzTooltipTitle="Limpiar filtros"
          aria-label="Limpiar filtros"
          (click)="limpiarTodosLosFiltros()"
        >
          <nz-icon nzType="clear" nzTheme="outline" />
        </button>
      }
      <!-- Mismo botón circular que usa la toolbar de intelishs-data-table. -->
      <button
        type="button"
        class="btn-refresh-circle"
        nz-tooltip
        nzTooltipTitle="Recargar"
        aria-label="Recargar"
        [disabled]="loading()"
        (click)="cargar()"
      >
        <nz-icon [nzType]="loading() ? 'loading' : 'reload'" nzTheme="outline" />
      </button>
    </div>
  </div>

  <!-- Calendar Layout -->
  <div class="cal-layout">
    <div class="cal-main">
      <!-- FullCalendar -->
      <div class="calendar-wrap">
        <full-calendar [options]="calendarOptions" />
        @if (loading()) {
          <div class="cal-loading-overlay" aria-busy="true" aria-live="polite">
            <nz-icon nzType="loading" nzSpin class="cal-loading-icon" />
            <span class="cal-loading-text">Cargando vacaciones…</span>
          </div>
        }
      </div>
    </div>

    <!-- Detail Panel -->
    <div class="cal-detail-panel" #panelDia>
      @if (selectedDate(); as sel) {
        <div class="cal-detail-header">
          <div class="cal-detail-weekday">{{ formatSelectedWeekday(sel) }}</div>
          <h3 class="cal-detail-title">{{ formatSelectedDate(sel) }}</h3>
        </div>

        <!-- Festivo del día seleccionado -->
        @if (selectedDayHoliday(); as nombre) {
          <div class="cal-detail-holiday">
            <nz-icon nzType="star" nzTheme="fill" />
            <div>
              <strong>Día festivo oficial</strong>
              <p>{{ nombre }}</p>
            </div>
          </div>
        }

        @if (selectedDayEvents().length > 0) {
          <div class="cal-detail-section-label">
            <nz-icon nzType="team" />
            <span
              >{{ selectedDayEvents().length }}
              {{ selectedDayEvents().length === 1 ? 'ausencia' : 'ausencias' }}</span
            >
          </div>
          <div class="cal-detail-list">
            @for (event of selectedDayEvents(); track event.empleadoId) {
              <div
                class="cal-detail-item cal-detail-item-clickable"
                [style.border-left-color]="getEventColor(event.estatus)"
                (click)="filtrarPorEmpleado(event.empleadoId, event.empleadoNombre)"
                title="Filtrar el calendario por este empleado"
              >
                <!-- Nombre a ancho completo y su contexto debajo. El estatus
                     compartía renglón con el nombre y lo partía en dos líneas;
                     el ID iba en una píldora gris, la única del sistema —en el
                     resto de la app el ID es texto plano en la línea meta—.

                     El estatus toma el color de la barra izquierda, misma
                     fuente, así que no lleva punto propio: la barra ya es la
                     señal de color y un punto sería la tercera. -->
                <div class="cal-detail-name" [title]="event.empleadoNombre">
                  {{ event.empleadoNombre }}
                </div>
                <div class="cal-detail-meta">
                  @if (event.empleadoIdInterno) {
                    <span class="cal-detail-id">{{ event.empleadoIdInterno }}</span>
                    <span class="cal-detail-sep">·</span>
                  }
                  <span class="cal-detail-estatus" [style.color]="getEventColor(event.estatus)">
                    {{ event.estatus }}
                  </span>
                </div>
                <div class="cal-detail-row">
                  <nz-icon nzType="apartment" />
                  <span>{{ event.area ?? 'Sin área' }}</span>
                </div>
                <div class="cal-detail-row">
                  <nz-icon nzType="calendar" />
                  <span>{{ formatEventRange(event.fechaInicio, event.fechaFin) }}</span>
                  <span class="cal-detail-dias"
                    >· {{ event.dias }} {{ event.dias === 1 ? 'día' : 'días' }}</span
                  >
                </div>
              </div>
            }
          </div>
        } @else if (!selectedDayHoliday()) {
          <intelishs-empty-state
            icon="calendar"
            [message]="
              hayFiltroActivo()
                ? 'Sin ausencias este día con los filtros activos'
                : 'Sin ausencias este día'
            "
          />
        }
      } @else {
        <intelishs-empty-state icon="select" message="Selecciona un día para ver detalles" />
      }
    </div>
  </div>
</div>
